import { PromptRegisterListItem } from '../models/prompt-register-results.model';
import { GetPrompts_promptsConnection_items } from '../queries/generated/GetPrompts';

export const promptRegisterColumns: string[] = ['promptType', 'name', 'active'];

export function convertPromptRegisterListItem(
   getPromptItem: GetPrompts_promptsConnection_items
): PromptRegisterListItem {
   return {
      active: getPromptItem.isActive,
      createDate: getPromptItem.createDate,
      createUserName: getPromptItem.createUser?.name || null,
      promptId: getPromptItem.promptId,
      typeName: getPromptItem.promptTypeName,
      name: getPromptItem.name,
      updateDate: getPromptItem.updateDate,
      updateUserName: getPromptItem.updateUser?.name || null,
      isReusable: getPromptItem.isReusable,
      autoAttendantConnection: getPromptItem.autoAttendantPromptsConnection?.items || null,
      queuePeriodicAnnouncementsConnection: getPromptItem.queuePeriodicAnnouncementsConnection?.items || null,
      queueMusicOnHoldConnection: getPromptItem.queueMusicOnHoldConnection?.items || null,
      accountMusicOnHoldConnection: getPromptItem.accountMusicOnHoldConnection?.items || null,
      closedExceptionPromptsConnection: getPromptItem.closedExceptionPromptsConnection?.items || null,
      queueCallbackPromptsConnection: getPromptItem.queueCallbackPromptsConnection?.items || null,
      mailboxUnavailablePromptsConnection: getPromptItem.mailboxUnavailablePromptsConnection?.items || null,
      mailboxNamePromptsConnection: getPromptItem.mailboxNamePromptsConnection?.items || null,
      mailboxBusyPromptsConnection: getPromptItem.mailboxBusyPromptsConnection?.items || null,
      isInUse: getPromptItem.isInUse,
      mailboxTemporaryUnavailablePromptsConnection:
         getPromptItem.mailboxTemporaryUnavailablePromptsConnection?.items || null,
   };
}
